import React from 'react';
import { connect } from 'react-redux'
import axios from 'axios';
import Loading from '../App/Loading';
import { Container, Row } from 'reactstrap';
import MatTable from './components/Table/MatTable';

class DevisCollection extends React.Component {

  constructor(props) {
    super(props)
    this.listingMapping = {
      '/devis/pending': {
        type: 'pending',
        title: 'Devis en attente de signature'
      },
      '/devis/completed': {
        type: 'completed',
        title: 'Devis signés'
      }
    }
    this.pageTitle = this.listingMapping[props.location.pathname].title;
    this.state = {
      loaded: false,
      loading: true,
      formatted: [],
      devis: [],
      user: {
        ...props.user
      }
    }
  }

  componentDidMount() {
    const listingKey = this.listingMapping[this.props.location.pathname].type;
    axios.post(`${process.env.REACT_APP_API_ENDPOINT}/user/dashboards/annonceurs/get-sidebar/`, {
      'userid': this.props.user.id
    }).then(res => {
      const data = res.data;
      // console.log(data);
      this.setState({
        ...this.state,
        loaded: true,
        devis: data.devis[listingKey].collection
      })
    })
  }

  render() {
    const { loaded, loading } = this.state;
    return (
      <Container className="dashboard">
        <Loading loaded={loaded} loading={loading} />
        {
          loaded && (
            <Row>
              <MatTable history={this.props.history} data={this.state.devis} title={this.pageTitle} />
            </Row>
          )
        }
      </Container>
    )
  }
}

const mapStateToProps = (state) => ({
  ...state.authentication
});
export default connect(mapStateToProps)(DevisCollection);